import React from 'react'
import './Dashboardhome.css'
function Dashboardhome() {
  return (
      <>
          <div className='dashboardwidth'>
              <div className="dashboardimage">

              </div>
          </div>
          
          
      </>
  )
}

export default Dashboardhome